import { createContext } from "react";

export const FunctContext = createContext({
  Path: "/",
  setPath: () => {},
  cl: () => {},
  GetDate: () => {},
  isLoggedIn: false,
  token: null,
  userId: null,
  Name: null,
  Email: "",
  AccountType: null,
  logoutTime: null,
  login: () => {},
  logout: () => {},
});
